<template>
   <span>
       {{this.$getDictName(cateVal,vval)}}
   </span>
</template>
<script>
    export default {
        props: ["category","v"],
        computed: {
            cateVal: function () {
                if(!this.category){
                    return null;
                }
                return this.category;
            },
            vval:function () {
                return this.v;
            }
        },
    }
</script>
